import { Box } from "@mantine/core";
import { colors } from "theme";

const DJSeparator = () => {
  return (
    <Box
      my={16}
      sx={{
        "&": {
          width: "100%",
          height: "1px",
          background: colors.grey[10],
        },
      }}
    />
  );
};

export default DJSeparator;
